export enum TipoPagoBoleta {
  DEFAULT = '',
  PAGADO = 'PAGADO',
  PENDIENTE_PAGO = 'PENDIENTE_PAGO',
  VENCIDO = 'VENCIDO',
}
